<template>
    <v-main
            v-touch="{right: () => swipe()}"
    >
        <v-breadcrumbs v-if="player && player.info" :items="items"></v-breadcrumbs>
        <v-container v-if="player && player.info" >
            <v-row>
                <v-col md="12" lg="8">
                    <v-card flat class="px-2">
                        <!--        PLAYER DATA AND TOP STUFF -->
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-row justify="center"
                                       align="center"
                                       style="height:100%">
                                    <v-col cols="12" class="text-center" v-if="player">
                                        <div style="padding:5px;display:inline-block;cursor:pointer;background-color: #eee;border-radius:10px; border: solid thin #888888;"
                                             @click="uploadtrigger=true">
                                            <v-avatar size="150px">
                                                <img  :src="player.info.profilepic"/>
                                            </v-avatar>
                                            <v-icon>{{icons.camera}}</v-icon>
                                        </div>
                                        <v-row>
                                            <v-col
                                                    class="headline font-weight-light text-right"
                                                    cols="6"
                                            >
                                                <v-btn text
                                                       @click="updatingvalues('firstname',player.info.firstname,'players','info')">
                                                    {{player.info.firstname||'FirstName'}}
                                                    <v-icon>{{icons.edit}}</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                    class="headline font-weight-light text-left"
                                                    cols="6">
                                                <v-btn text
                                                       @click="updatingvalues('lastname',player.info.lastname,'players','info')">
                                                    {{player.info.lastname||'LastName'}}
                                                    <v-icon>{{icons.edit}}</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" v-if="!editlocked" class="py-0">
                                                <Uploader @newfiles="setProfilePic($event)" :limitone="true"
                                                          :trigger="uploadtrigger" @closing="uploadtrigger=false"/>
                                            </v-col>
                                            <v-col cols="12" class="pa-0" v-if="$prms(['admin','director'])">
                                                <v-btn text :to="`/myathletes/profile/${player.partkey}/admin`" >
                                                    <v-icon small>{{icons.cog}}</v-icon> Admin
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
            <!--                END JUSTIFIED COLUMN                        -->
                            </v-col>
                            <!--PLAYER BODY MEAS LIST-->
                            <v-col cols="12" sm="6">
                                <v-card outlined>
                                    <v-list>
                                        <v-subheader inset>
                                            {{sportcode}}
                                        </v-subheader>

                                        <v-list-item
                                                :disabled="editlocked"
                                                @click="updatingvalues('gradyear',player.info.gradyear,'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">mdi-school-outline</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{player.info.gradyear}}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>Grad Year</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('email',player.info.email,'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">{{icons.email}}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{player.info.email}}</v-list-item-title>
                                                <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action v-if="player.info.email && !player.info.emailverified">
                                                <v-btn icon @click.stop="emailverifydialog=true">
                                                    <v-icon>{{icons.info}}</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('cell',player.info.cell,'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">{{icons.call}}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{player.info.cell}}</v-list-item-title>
                                                <v-list-item-subtitle>Cell</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('birthday',player.info.birthday,'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">{{icons.calendar}}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{player.info.birthday}}</v-list-item-title>
                                                <v-list-item-subtitle>Birthday</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('about',player.info.about, 'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">{{icons.info}}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>About Me</v-list-item-title>
                                                <v-list-item-subtitle>{{player.info.about}}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>



                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('instagram',player.info.instagram, 'players','info',null)">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">mdi-instagram</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{player.info.instagram}}</v-list-item-title>
                                                <v-list-item-subtitle>Instagram</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked"
                                                     @click="updatingvalues('sandrecruit',player.info.sandrecruit, 'players','info',null)"
                                                     v-if="(sportcode==='beach')">
                                            <v-list-item-avatar>
                                                <v-icon color="awesome">S</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{player.info.sandrecruit}}</v-list-item-title>
                                                <v-list-item-subtitle>Sandrecruit</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked" >
                                            <v-list-item-action>
                                                <v-checkbox v-model="isactive"  @change="setStatus($event)"/>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <span class="text-capitalize">{{isactive ? player.sport[sportcode].status : 'Archived'}}</span>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked" >
                                            <v-list-item-action>
                                                <v-checkbox v-model="player.sport[sportcode].public"  @change="setPublic($event)"/>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                {{player.sport[sportcode].public===true?'Public - This will show publicly':'Not Public - not visible to public'}}
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item class="plrl" :disabled="editlocked" v-if="dev" >
                                            <v-list-item-action>
                                                <v-checkbox   />
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                {{player.sport[sportcode].public===true?'Graduated':''}}
                                            </v-list-item-content>
                                        </v-list-item>

                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!--CLUB AND COLLEGE BLOCK-->
                        <v-row v-if="1===1">
                            <v-col cols="4" v-if="displayclub && displayclub.partkey != 'unaffl'">
                                <div @click="handleclubdialog(), getclubs()">
                                    <img v-if="displayclub.logo" :src="displayclub.logo" height="40"/>
                                    <h3 class="font-weight-thin">{{displayclub.fullname}}</h3>
                                </div>
                            </v-col>
                            <v-col cols="4" v-else>
                                <v-btn text @click="clubdialog = true, getclubs()">
                                    <v-icon :small="$vuetify.breakpoint.smAndUp" class="mr-1">mdi-tshirt-crew-outline</v-icon>
                                    <span class="hidden-xs-only">Unaffiliated</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="4" v-if="committed" class="text-center">
                                <v-badge right>
                                    <v-icon
                                            slot="badge"
                                            class="white--text"
                                            @click.native="decommitdialog = true"
                                    >
                                        {{icons.close}}
                                    </v-icon>
                                    <div @click="commitdialog = true">
                                        <img :src="displaycommit.img" height="50"/>
                                        <h3 class="font-weight-thin">{{displaycommit.name}}</h3>
                                    </div>
                                </v-badge>
                            </v-col>
                            <v-col cols="4" v-else class="text-center" >
                                <v-btn text block @click="commitdialog = true">
                                    <v-icon :small="$vuetify.breakpoint.smAndUp" class="mr-1">mdi-school-outline</v-icon>
                                    <span class="hidden-xs-only">Not Committed</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="4" class="text-right">
                                <v-btn text @click="geteditors()">
                                    <v-icon :small="$vuetify.breakpoint.smAndUp">{{icons.edit}}</v-icon>
                                    <span class="hidden-xs-only">Profile Editors</span>
                                </v-btn>
                            </v-col>
                        </v-row>


                        <!--BOTTOM PANEL BUTTONS-->
                        <v-card color="awesome">
                            <v-row justify="center" class="py-0">

                                <v-col cols="4" class="text-center">
                                    <v-btn outlined fab color="white" @click="measurementdialog = true" class="bfab">
                                        <v-icon>mdi-chart-bar</v-icon>
                                    </v-btn>
                                    <p class="white--text">Msments</p>
                                </v-col>


                                <v-col cols="4" class="text-center">
                                    <v-btn v-bind:disabled="!player.info.emailverified" outlined fab color="white"
                                           @click.native="sharedialog = true" class="bfab">
                                        <v-icon>{{icons.email}}</v-icon>
                                    </v-btn>
                                    <p class="white--text">Send</p>
                                </v-col>


                                <v-col cols="4" class="text-center">
                                    <v-btn outlined fab :loading="loadingmetrics" color="white" @click="metricsdialogshow"
                                           class="bfab">
                                        <v-icon>{{icons.checkon}}</v-icon>
                                    </v-btn>
                                    <p class="white--text">Metrix</p>
                                </v-col>


                                <v-col cols="4" class="text-center">
                                    <v-btn outlined fab color="white" class="bfab"
                                           @click="achievementdialog=true, handleachievements('get')">
                                        <v-icon>mdi-trophy-award</v-icon>
                                    </v-btn>
                                    <p class="white--text">Achievements</p>
                                </v-col>


                                <v-col cols="4" class="text-center">
                                    <v-btn outlined fab color="white" class="bfab" @click="scheduledialog=true, getevents()">
                                        <v-icon class="flip">{{icons.calendar}}</v-icon>
                                    </v-btn>
                                    <p class="white--text">Schedule</p>
                                </v-col>

                                <v-col cols="4" class="text-center">
                                    <v-btn outlined fab color="white" class="bfab">
                                        <Notepad :tag="player.partkey" color="white" />
                                    </v-btn>
                                    <p class="white--text">Notes</p>
                                </v-col>


                                <v-col cols="4" class="text-center" v-if="1===2">
                                    <v-btn outlined fab disabled color="white" class="bfab" :to="'/playerprofile/'+ player.partkey">
                                        <v-icon>mdi-iframe-outline</v-icon>
                                    </v-btn>
                                    <p class="white--text">My Page</p>
                                </v-col>


                            </v-row>
                        </v-card>


                        <!--  DIALOGS  -->
                        <v-row>

                            <v-col cols="6">
                                <v-btn block
                                       outlinedlarge
                                       :to="`${player.partkey}/videos`"
                                       color="awesome" class="white--text">
                                    <v-icon>{{icons.video}}</v-icon>
                                    <span class="hidden-xs-only pr-1">Videos of </span> {{player.info.firstname||''}}
                                </v-btn>
                            </v-col>

                            <v-col cols="6">
                                <!--                       <v-btn block outlined large @click.native="profilevideodialog = true"-->
                                <!--                              color="awesome" class="white&#45;&#45;text">-->
                                <!--                           <v-icon>mdi-video</v-icon>-->
                                <!--                           Profile Videos-->
                                <!--                       </v-btn>-->
                                <PlayerProfileVideos block outlined large/>
                            </v-col>


                        </v-row>

                        <!--SHARE-->
                        <v-dialog v-model="sharedialog"
                                  fullscreen
                                  :overlay="false"
                                  scrollable

                        >
                            <v-card text>
                                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                                    <v-btn icon @click.native="sharedialog = false" dark>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>Share {{player.info.firstname||'Player'}}'s Profile</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>


                                <v-card-text>
                                    <Share
                                            :player="player"
                                            v-on:closeshare="closeShareDialog"
                                    />
                                </v-card-text>

                                <v-card-actions>


                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--MEASUREMENTS DIALOG-->
                        <v-dialog v-model="measurementdialog"
                                  max-width="400"
                                  :overlay="false"
                                  scrollable

                        >
                            <v-card>
                                <v-card-title>
                                    {{player.info.firstname||'Player'}}'s Measurements
                                </v-card-title>
                                <v-card-text>
                                    <v-card outlined>
                                        <v-list>
                                            <v-list-item v-for="(v,n,i) in meas_model"
                                                         v-bind:key="i"
                                                         @click="updatingvalues(v.title, (player.sport[sportcode]['measurements'][v.title]||0), v.id, 'measurements', n)">
                                                <v-list-item-content>
                                                    {{v.title}}
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    {{ player.sport[sportcode]['measurements'][v.title]||0 }}
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text @click="measurementdialog=false">
                                        <v-icon>{{icons.close}}</v-icon>
                                        Close
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--UPDATER DIALOG-->
                        <v-dialog
                                v-model="updatedialog"
                                max-width="400">
                            <v-card>
                                <v-card-title class="headline text-uppercase">{{activedataname}}</v-card-title>
                                <v-card-text>
                                    {{activedatavalue}}
                                    <v-textarea
                                            v-if="activedataname==='about'"
                                            outlined
                                            :label="activedataname"
                                            v-model="activedatavalue"
                                            class="input-group--focused"
                                    ></v-textarea>
                                    <v-text-field
                                            outlined
                                            v-else
                                            :label="activedataname"
                                            v-model="activedatavalue"
                                            class="input-group--focused"
                                    ></v-text-field>

                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="awesome darken-1" text @click.native="updatedialog = false">Cancel</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="awesome darken-1" text @click.native="update">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--UPDATER FOOT DIALOG-->
                        <v-dialog v-model="updatefootmodal"
                                  max-width="400"
                        >
                            <v-card>
                                <v-card-title class="headline">{{activedataname}}</v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-text-field
                                                        outline
                                                        value=""
                                                        class="input-group--focused"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field
                                                        outline
                                                        value=""
                                                        class="input-group--focused"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text @click.native="updatefootmodal = false">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click.native="update">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--METRIX DIALOG-->
                        <Metrics ref="metrix" :metricsdialog="showmetrix" @close="showmetrix=false"></Metrics>


                        <v-dialog v-model="emailverifydialog"
                                  fullscreen
                                  transition="dialog-bottom-transition"
                                  :overlay="false"
                                  scrollable
                        >
                            <v-card text>
                                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                                    <v-btn icon @click.native="emailverifydialog = false" dark>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>Verify {{player.info.email}}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-card-text>
                                    <p>
                                        We use Amazon Web Services to send "share" emails. And we hate spam.
                                        You will need to verify ownership of the email address before you can send emails with
                                        the app. This is DIFFERENT than the link sent to register.
                                    </p>
                                    <ul>
                                        <li>
                                            1.) Click 'VERIFY NOW' to send a verification email to the player-email listed above. It
                                            will come from Amazon Web Services
                                        </li>
                                        <li>
                                            2.) Click the link in the email, you will be re-directed to Amazon Web Services
                                            verification
                                            page.
                                        </li>
                                        <li>
                                            3.) Click 'CHECK VERIFICATION STATUS' to confirm
                                        </li>
                                        <li>
                                            4.) That's it! In a few minutes your email will be ready to use!
                                        </li>
                                    </ul>
                                    <v-btn text @click.native="verifyemail(player.info.email)">verify now</v-btn>
                                </v-card-text>
                                <v-card-actions></v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="emailconfirmed" max-width="500px">
                            <v-card>
                                <v-img
                                        class="white--text"
                                        src="/static/20171223_133011.jpg"
                                        height="300px"
                                >
                                    <v-container fill-height fluid>
                                        <v-layout fill-height>
                                            <v-flex xs12 align-end flexbox>
                                                <span class="headline">Rock ON!</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>

                                </v-img>
                                <v-card-text>
                                    <h4>
                                        Your email has been confirmed!
                                    </h4>
                                    <p>
                                        Now go! <br/>Send one! <br/>To a real coach!
                                    </p>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text="text" outline
                                           @click.native="emailconfirmed = false "
                                    >
                                        OK! I'm ON it!
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="clubdialog" max-width="500px">
                            <v-card>
                                <v-card-title>
                                    Request to join a supported club
                                </v-card-title>
                                <v-card-text>
                                    <v-row v-for="c in clubs" :key="c.name" class="py-0">
                                        <v-col cols="6" class="py-0">
                                            <v-btn small outlined block @click="requestjoinclub(c)">
                                                Join
                                                {{c.name}}
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="3" class="py-0">

                                        </v-col>
                                        <v-col cols="3" class="py-0">
                                            <img :src="c.logo" height="20"/>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn outlined @click="clubdialog = false, clubconfirmdialog=false,requestedclub='' ">Cancel
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <!--CLUB DIALOG CONFIRM-->
                        <v-dialog v-model="clubconfirmdialog" max-width="400px">
                            <v-card>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <div class="subheading">
                                                <img :src="requestedclub.logo" height="40"/>
                                                We will send a request for
                                                {{player.info.firstname}}
                                                to join {{requestedclub.name}} ?
                                            </div>
                                            <div class="caption">
                                                Note: this profile can only belong to 1 club at a time. Any videos or data owned by
                                                the
                                                club will not follow the profile
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn outlined @click="clubdialog = false, clubconfirmdialog=false,requestedclub='' ">Cancel
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn outlined
                                           @click="sendrequest(requestedclub.partkey, player.partkey, 'join', player.info, 'Request to join '+requestedclub.name, requestedclub.logo )">
                                        Confirm
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <SetCommit
                                :commitdialog="commitdialog"
                                :decommitdialog="decommitdialog"
                                :displaycommit="displaycommit"
                                @close="commitdialog=false,decommitdialog=false"
                                @success="selectPlayer(player.partkey)" />


                        <v-dialog v-model="editorsdialog" max-width="400">
                            <v-card>
                                <v-card-title>Add Editor</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" v-if="neweditor!=''">
                                            {{neweditor.user}}
                                        </v-col>
                                        <v-col cols="12" v-if="!founduser">
                                            <v-text-field
                                                    label="New Editor"
                                                    placeholder="Enter username of new editor"
                                                    v-model="neweditor"
                                                    outlined
                                                    :append-outer-icon="icons.search"
                                                    @click:append-outer="findUser()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" v-if="founduser" class="title">{{founduser.username}}</v-col>
                                        <v-col cols="5" v-if="founduser" class="title">{{founduser.email}}</v-col>
                                        <v-col cols="3">
                                            <v-progress-circular
                                                    class="pl-2"
                                                    v-if="searchinguser"
                                                    indeterminate
                                                    color="primary"
                                            ></v-progress-circular>
                                            <v-btn v-if="founduser" outlined @click="handleeditor(founduser.sub,'add')">Add</v-btn>
                                            <v-btn v-if="founduser" outlined
                                                   @click="neweditor='',founduser=false,searchinguser=false">
                                                Search Again
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            {{player.info.firstname||'FirstName'}} {{player.info.lastname||'LastName'}}'s card is
                                            shared
                                            with the following users. They can view and edit the profile card.
                                            <v-list>
                                                <v-list-item v-for="(e,i) in editors" :key="i">
                                                    <v-list-item-content>
                                                        {{e.username}}
                                                    </v-list-item-content>
                                                    <v-list-item-content>
                                                        {{e.email}}
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-list-item-content v-if="player.canedit.includes(i)">
                                                            OWNER
                                                        </v-list-item-content>
                                                        <v-list-item-content v-else-if="$store.state.token.sub==i">
                                                            YOU
                                                        </v-list-item-content>
                                                        <v-btn v-else text @click="handleeditor(i,'remove')">remove</v-btn>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text color="awesome"
                                           @click="editorsdialog=false,neweditor='',founduser=false,searchinguser=false">Cancel
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <!--SCHEDULE DIALOG-->
                        <v-dialog v-model="scheduledialog"
                                  :overlay="false"
                                  scrollable
                                  fullscreen
                                  fixed
                        >
                            <v-card text>
                                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                                    <v-btn icon @click.native="scheduledialog = false" dark>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{player.info.firstname||'Player'}} - Events</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn text @click="searchscheduledialog=true">Add Date</v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>

                                    <v-layout row wrap>
                                        <v-list three-line>
                                            <template v-for="(e,i) in myevents">
                                                <v-list-item
                                                        :key="e.id">
                                                    <v-list-item-action>
                                                        <v-btn icon ripple @click="confirmeventremove(e)">
                                                            <v-icon color="orange lighten-1">fas fa-minus</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{new Date(e.date).toLocaleDateString("en-US")}}
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>{{e.name}} | {{e.location}}
                                                            <br/><a :href="e.url" target="_blank">{{e.url}}</a>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-layout>

                                </v-card-text>
                                <v-card-actions></v-card-actions>
                            </v-card>
                        </v-dialog>


                        <!--SCHEDULE DIALOG-->
                        <v-dialog v-model="searchscheduledialog"
                                  :overlay="false"
                                  scrollable
                        >
                            <v-card text>
                                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                                    <v-btn icon @click.native="searchscheduledialog = false, searchstring='', events=[]" dark>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{player.info.firstname||'Player'}} - Events</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 md3>
                                            <v-text-field
                                                    label="Event Name or Location"
                                                    placeholder="Search"
                                                    v-model="searchstring"
                                                    @keyup="searchevent()"
                                                    outline
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row wrap>
                                        <v-list three-line>
                                            <template v-for="(e,i) in events">
                                                <v-list-item
                                                        :key="e.id">
                                                    <v-list-item-action>
                                                        <v-btn icon ripple @click="confirmeventadd(e)">
                                                            <v-icon color="green lighten-1">fas fa-plus</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{e.name}}</v-list-item-title>
                                                        <v-list-item-subtitle>{{e.location}} | {{new
                                                            Date(e.date).toLocaleDateString("en-US")}}
                                                            <br/><a :href="e.url" target="_blank">{{e.url}}</a>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-layout>

                                </v-card-text>
                                <v-card-actions></v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="confirmevent">
                            <v-card>
                                <v-card-text>
                                    would you like to add
                                    <div class="subheading">
                                        {{activeevent.name}}
                                    </div>
                                    on
                                    <div class="subheading">
                                        {{new Date(activeevent.date).toLocaleDateString("en-US")}}
                                    </div>
                                    to your upcoming play?
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn outlined @click="handleevent('addto')">Yes</v-btn>
                                    <v-btn outlined @click="confirmevent=false,activeevent=''">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="confirmeventr">
                            <v-card>
                                <v-card-text>
                                    Remove
                                    <div class="subheading">
                                        {{activeevent.name}}
                                    </div>
                                    on
                                    <div class="subheading">
                                        {{new Date(activeevent.date).toLocaleDateString("en-US")}}
                                    </div>
                                    from your event - play?
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn outlined @click="handleevent('delete')">Yes</v-btn>
                                    <v-btn outlined @click="confirmeventr=false,activeevent=''">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <!--ACHEIVEMENT DIALOG-->
                        <v-dialog v-model="achievementdialog"
                                  :overlay="false"
                                  scrollable
                                  max-width="500"
                        >
                            <v-card>
                                <v-card-title>
                                    {{player.info.firstname||'Player'}} - Achievements
                                </v-card-title>
                                <v-card-text>
                                    <v-list three-line>
                                        <template v-for="(e,i) in myachievements">
                                            <v-list-item
                                                    :key="e.id">
                                                <v-list-item-action>
                                                    <v-btn icon ripple
                                                           @click="newachievement=e, confirmdeleteachievementdialog=true">
                                                        <v-icon color="orange lighten-1">{{icons.minus}}</v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{e.name}}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>{{e.description}}
                                                        <v-btn icon small @click="newachievement=e, hanldeachievementdialog=true">
                                                            <v-icon>fas fa-edit</v-icon>
                                                        </v-btn>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text @click="achievementdialog=false">
                                        <v-icon>{{icons.close}}</v-icon>
                                        Close
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="hanldeachievementdialog=true">
                                        <v-icon>{{icons.plus}}</v-icon>
                                        Add
                                    </v-btn>
                                </v-card-actions>
                            </v-card>

                        </v-dialog>


                        <v-dialog v-model="hanldeachievementdialog" max-width="400">
                            <v-card>
                                <v-card-title>
                                    Add Achievement
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" class="py-0">
                                            <v-text-field
                                                    label="Outline"
                                                    placeholder="Placeholder"
                                                    outlined
                                                    v-model="newachievement.name"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-textarea
                                                    outlined
                                                    label="Description"
                                                    v-model="newachievement.description"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text
                                           @click="hanldeachievementdialog=false,newachievement.name='', newachievement.description=''">
                                        Cancel
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="handleachievements('add')">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="confirmdeleteachievementdialog" max-width="350">
                            <v-card>
                                <v-card-title>Remove Achievement</v-card-title>
                                <v-card-text>
                                    Remove {{newachievement.name}} from your achievements?
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text @click="confirmdeleteachievementdialog=false">
                                        <v-icon>
                                            {{icons.close}}
                                        </v-icon>
                                        Cancel
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="handleachievements('delete')">Continue</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="requestdialog" v-if="myrequests">
                            <v-card>
                                <v-card-text>
                                    <v-list three-line>
                                        <template v-for="(r,i) in myrequests">
                                            <v-list-item
                                                    :key="r.id">
                                                <v-list-item-action>
                                                    <v-list-item-avatar>
                                                        <img :src="r.image">
                                                    </v-list-item-avatar>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{new Date(r.createdAt).toLocaleDateString("en-US")}}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>{{r.description}}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn outlined @click="requestdialog=false">Close</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>


                        <v-dialog v-model="addnotedialog">
                            <v-card>
                                <v-card-title>Add Note</v-card-title>
                                <v-card-text>
                                    <v-flex row wrap>
                                        <v-flex xs12>
                                            <v-textarea
                                                    label="Outline"
                                                    placeholder="Placeholder"
                                                    outlined
                                                    v-model="notetext"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-flex>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text @click="savenote()">save</v-btn>
                                    <v-btn text @click="addnotedialog=false">cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card>
                </v-col>
            </v-row>
            <TrackableLink v-if="1===3" />
        </v-container>
        <v-container v-if="player===false">
            <v-row>
                <v-col cols="12">
                    <v-btn text to="/myathletes">
                        <v-icon>{{icons.arrowleft}}</v-icon>
                        Back
                    </v-btn>
                    <h3> No data available</h3>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-if="player===undefined">
            <v-row>
                <v-col cols="12">
                    <h3>... Loading Player</h3>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import mm from '@/views/a4l/MeasurementModel.js'
  import Share from '@/views/a4l/Share'
  import Metrics from '@/views/a4l/Metrics'
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import PlayerProfileVideos from "@/views/a4l/playercomponents/PlayerProfileVideos";
  import SetCommit from "./playercomponents/SetCommit";
  import TrackableLink from "./playercomponents/TrackableLink";

  export default {
    name: 'Player',
    components: {
      AdminPanel: ()=>import('@/views/a4l/playercomponents/AdminPanel'),
      TrackableLink,
      SetCommit,
      PlayerProfileVideos,
      Uploader: () => import('@/components/uploader/UploaderCropper'),
      Notepad: () => import('@/views/notes/NotepadJS'),
      AddNote: () => import('@/views/notes/AddNote'),
      Share,
      Metrics
    },
    data() {
      return {
        player: undefined,
        msmt: '',
        updatedialog: false,
        updatefootmodal: false,
        activedataname: '',
        activedatavalue: '',
        activetable: '',
        activeunits: '',
        meas_model: '',
        updatecol: '',// TODO make an object activemeas{code,id}
        activemeasid: '',
        measurementdialog: false,
        bottombuttons: true,
        profilevideodialog: false,
        sharedialog: false,
        emailverified: false,
        emailverifydialog: false,
        verifyableemail: false,
        emailconfirmed: false,
        activeprofile: false,
        handlingactive: false,
        editlocked: true,
        clubs: [],
        clubdialog: false,
        club: 'CLUB',
        clubconfirmed: false,
        displayclub: false,
        tmpclub: false,
        committed: false,
        searchresults: false,
        displaycommit: false,
        commitdialog: false,
        decommitdialog: false,
        playerwidth: 400,
        playerheight: 390,
        playerembedid: '',
        editorsdialog: false,
        editors: false,
        neweditor: '',
        founduser: false,
        searchinguser: false,
        scheduledialog: false,
        searchstring: '',
        neweventname: '',
        neweventurl: '',
        events: [],
        myevents: [],
        activeevent: '',
        confirmevent: false,
        confirmeventr: false,
        searchscheduledialog: false,
        achievementdialog: false,
        myachievements: [],
        hanldeachievementdialog: false,
        newachievement: {
          name: '',
          description: '',
          id: false
        },
        confirmdeleteachievementdialog: false,
        clubdialogOLD: false,
        clubconfirmdialog: false,
        requestedclub: '',
        myrequests: false,
        requestdialog: false,
        notetext: '',
        notebookdialog: false,
        addnotedialog: false,
        showmetrix: false,
        loadingmetrics: false,
        uploadtrigger:false,
        items:[]
      }
    },
    computed: {
      ...mapState(['org', 'icons','activeplayer','athleteobject','sportcode','permissions','myathletes','dev']),
      dialog(){
        return this.activeplayer?true:false
      },
      isactive:{
        get(){
          return(this.player.sport[this.sportcode].status==='active')?true:false
        },
        set(val){
          console.log(val)
          if(val){
            this.player.sport[this.sportcode].status = 'active'
          }else{
            this.player.sport[this.sportcode].status = 'archived'
          }
        }
      }
    },
    watch: {
      $route(){
        this.selectPlayer(this.$route.params.playerkey)
        this.$forceUpdate()
      },
      activeplayer(n,o){
        console.log('activeplayer')
        if(n===false){
          this.player=false;
          return
        }
        this.player = Object.assign({},n)
        this.$forceUpdate()
        if(n && n.info){
          this.items = [
            {
              text: 'My Athletes',
              to: '/myathletes',
            },
            {
              text: this.player.info.firstname+' '+this.player.info.lastname,
              disabled: false,
              to: '/myathletes/profile/'+this.player.partkey,
            },
            {
              text: this.player.info.firstname+'\'s Videos',
              disabled: false,
              to: '/myathletes/profile/'+this.player.partkey+'/videos',
            },
          ]
          this.committed = this.player.sport[this.sportcode].committed;
          this.editlocked = false;// this.player.editlocked;
          this.activeprofile = this.player.sport[this.sportcode].active;
          this.playerembedid = this.player.sport[this.sportcode].youtubevideo;
          this.displayclub = this.player.displayclub
          this.getvideos();
        }

      },
      committed(n, o) {
        if (n)
          this.getcollege(n)
      },
      displayclub(n) {
        if (n) {
          this.getclub(this.player.sport[this.sportcode].club.partkey)
        }
      }
    },
    created() {
      if(this.athleteobject[this.$route.params.playerkey]){
        //speeds up loading for any recent profiles
        let p = this.athleteobject[this.$route.params.playerkey]
        this.player = Object.assign({},p)
        console.log('createdhook',p,this.player)
        this.setActivePlayer(p)
      }
      this.selectPlayer(this.$route.params.playerkey)
    },
    mounted() {
      this.playerwidth = ((window.innerWidth - 32) > 640) ? 640 : (window.innerWidth - 32)
      this.playerheight = this.playerwidth * .609 //ratio of 390/640 - height:640 width:390
      this.meas_model = mm[this.sportcode];
    },
    methods: {
      ...mapActions(['get', 'post', 'put','selectPlayer','updateMyAthletes','checkPermissions']),
      ...mapMutations(['setActivePlayer','setVideoList','removeRecord']),
      swipe(){
        this.$router.push('/myathletes')
      },
      async getvideos(){
        let v = await this.get({path:'api/video/groupv2/'+this.activeplayer.partkey})
        this.setVideoList(v)
      },
      async findUser() {
        if (this.neweditor == '') return;
        this.searchinguser = !true
        let response = await this.get({path: 'api/playerv2/getuser/' + this.neweditor})
        this.searchinguser = false
        if (response.code) {
          return
        }
        response.UserAttributes.forEach(function (d) {
          if (d.Name === 'sub') {
            this.founduser.sub = d.Value
          }
          if (d.Name === 'email') {
            this.founduser.email = d.Value
          }
        })
        this.founduser = {
          username: response.Username
        }
      },
      handleeditor(key, action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/handleeditors',
          method: 'PUT',
          data: {
            partkey: this.player.partkey,
            info: this.player.info,
            sport: this.sportcode,
            key: key,
            action: action,
            canedit: this.player.sport[this.sportcode].canedit
          }
        }
        //PUT for change record
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.neweditor = '',
              em.founduser = false,
              em.searchinguser = false
            em.editorsdialog = false
            em.refresh()
          })
      },
      async geteditors() {
        let data = {
          editors: this.player.sport[this.sportcode].canedit
        }
        let response = await this.post({path: 'api/playerv2/profileeditors', body: data})
        console.log(response)
        this.editors = response
        this.editorsdialog = true;
      },
      getclubs() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/club/all/beach',
          method: 'GET'
        }
        //PUT for change record
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.clubs = data
          })
      },
      updatingvalues(name, value, mid, code, mmkey) {
        console.log(name, value, mid, code, mmkey)
        this.activeunits = ''
        if (code == 'measurements') {
          this.activeunits = mm[this.sportcode][mmkey].units;
        }
        if (this.editlocked) return;
        this.activedataname = name;
        this.activedatavalue = value
        if (code === 'measurements' && mm[this.sportcode][mmkey].units === 'ft') {
          this.updatedialog = true;

        } else {
          this.updatedialog = true;
        }
        this.updatecol = code;
        this.activemeasid = mid;
      },
      update() {
        // replace spaces with underscores to get the db.
        let a = this.activedataname.replace(' ', '_')
        let data = {
          partkey: this.player.partkey,
          sport: this.sportcode,
          col: this.updatecol,
          attribute: this.activedataname,
          value: this.activedatavalue
        }
        this.put({path: 'api/profilesv2', body: data})
        this.updatedialog = false;
        if (this.updatecol === 'measurements') {
          this.player.sport[this.sportcode][this.updatecol][this.activedataname] = this.activedatavalue;
        } else {
          this.player[this.updatecol][this.activedataname] = this.activedatavalue;
        }
        if(['firstname','lastname','profilepic'].includes(this.activedataname)){
          this.updateMyAthletes(data)
        }
      },
      metricsdialogshow() {
        var em = this;
        em.loadingmetrics = true;
        let p1 = this.$refs.metrix.loadEmails();
        let p2 = this.$refs.metrix.videoviews();
        let p3 = this.$refs.metrix.pageviews();
        Promise.all([p1, p2, p3]).then(function (r) {
          console.log(r)
          em.loadingmetrics = false;
          em.showmetrix=true
        });
      },
      verifyemail(eml) {
        let em = this
        let args = {
          url: this.$store.state.url + 'api/share/verifyemail',
          method: 'POST',
          data: {
            email: eml
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data);
            alert('A verification email has been sent');
            em.emailverifydialog = false;
          }).catch(function (e) {
          console.log(e);
        })
      },
      checkverificationstatus(eml) {
        var em = this;
        let args = {
          url: this.$store.state.url + 'api/share/checkverifiedemails',
          method: 'POST',
          data: {
            partkey: em.player.partkey,
            email: eml
          }
        }

        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data);
            if (data.verified) {
              em.emailverified = true;
              em.emailconfirmed = true;
              let data = this.player;
              data.info.emailverified = true;
              //em.$store.commit('activeplayer', data);
            } else {
              //handle error
            }
          }).catch(function (e) {
          console.log(e);
        })
      },
      async setStatus(event) {
        //show on publicprofile page or not
        console.log(event)
        if(!event){
          this.player.sport[this.sportcode].public = false
          this.player.sport[this.sportcode].status='archived'
        }else{
          this.player.sport[this.sportcode].status = 'active'
        }
        let data = {
          status: this.player.sport[this.sportcode].status,
          public: this.player.sport[this.sportcode].public,
          sport: this.sportcode,
          playerkey: this.player.partkey
        }
        let response = await this.put({path: 'api/playerv2/setstatus', body: data})
        this.removeRecord({list:'myathletes',key:this.player.partkey})
      },
      async setPublic(event) {
        //show on publicprofile page or not
        console.log(event)
        if(event){
          this.player.sport[this.sportcode].status = 'active'
          this.player.sport[this.sportcode].public = event
        }
        let data = {
          status: this.player.sport[this.sportcode].status,
          public: event,
          sport: this.sportcode,
          playerkey: this.player.partkey
        }
        let response = await this.put({path: 'api/playerv2/setpublic', body: data})
      },
      closeShareDialog() {
        this.sharedialog = false;
      },
      handleclubdialog() {
        //if(this.editlocked==true)return;
        this.tmpclub = this.displayclub.name
        this.clubdialog = true
      },
      handleclub() {
        this.displayclub = false
        let updated = this.player.sport[this.sportcode]
        updated.club = {
          partkey: this.club,
          confirmed: false
        }
        let data = {
          partkey: this.player.partkey,
          sport: this.sportcode,
          updated: updated,
          oldclub: this.tmpclub,
          grad: this.player.info.gradyear,
          fname: this.player.info.firstname,
          lname: this.player.info.lastname,
          profilepic: this.player.info.profilepic
        }
        this.put({path: 'api/playerv2/club', body: data})
        this.clubdialog = false
        this.getclub(this.club)
      },
      requestjoinclub(c) {
        console.log(c)
        this.clubconfirmdialog = true
        this.requestedclub = c
      },//todo get players existing club before sending request... hackable
      sendrequest(to, from, code, data, descrip, image) {
        console.log((to, from, code, data, descrip, image))
        data.oldclub = this.displayclub.name || null;
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/sendrequest',
          method: 'POST',
          data: {
            to: to,
            from: from,
            code: code,
            data: data,
            description: descrip,
            image: image
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (d) {
            em.clubconfirmdialog = false
            em.clubdialog = false
            em.getrequests()
          }).catch(function (e) {
          console.log(e)
        });
      },
      getrequests() {
        this.myrequests = this.get({path: 'api/event/getrequests/' + this.player.partkey})
      },
      async getclub(partkey) {
        let em = this;
        this.displayclub = await this.get({path: 'api/playerv2/playerclub/' + partkey})
      },
      async getcollege(partkey) {
        this.displaycommit = await this.get({path:'api/playerv2/college/' + partkey})
      },
      onResize() {
        this.windowSize = {x: window.innerWidth, y: window.innerHeight}
        this.playerwidth = ((window.innerWidth - 32) > 640) ? 640 : (window.innerWidth - 32);
        this.playerheight = this.playerwidth * .609
      },
      refresh() {
        let em = this;
        setTimeout(function () {
          em.$methods.getPlayer(this.player.partkey)
        }, 1000)
      },
      schedule(action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/schedule',
          method: 'POST',
          data: {
            player: this.player.partkey,
            action: action
          }
        }
        //PUT for change record
        this.events.push({name: this.neweventname, url: this.neweventurl})
        this.neweventname = '';
        this.neweventurl = '';
//                this.$store.dispatch('fetch',args)
//                .then(function(data){console.log(data)})
      },
      searchevent() {
        if (this.searchstring == '') {
          return
        }
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: 'search',
            searchstring: this.searchstring
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.events = data
          })
      },
      confirmeventadd(e) {
        this.activeevent = e
        this.confirmevent = true
      },
      confirmeventremove(e) {
        this.activeevent = e
        this.confirmeventr = true
      },
      handleevent(action) {
        console.log(action)
        //if(this.searchstring==''){return}
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: action,
            player: this.player.partkey,
            eventid: this.activeevent.id,
            searchstring: this.searchstring
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data)
            em.activeevent = false;
            em.searchstring = '';
            em.confirmevent = false;
            em.confirmeventr = false;
            em.events = [];
            em.searchscheduledialog = false;
            em.getevents('get');
          })
      },
      getevents(action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: 'get',
            player: this.player.partkey
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.myevents = data
          })
      },
      handleachievements(action) {
        let em = this;
        if (action == 'add' && this.newachievement.id) {
          action = 'update'
        }
        let args = {
          url: this.$store.state.url + 'api/event/achievements',
          method: 'POST',
          data: {
            action: action,
            name: this.newachievement.name,
            description: this.newachievement.description,
            player: this.player.partkey,
            id: this.newachievement.id
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.hanldeachievementdialog = false;
            em.newachievement = {
              name: '',
              description: '',
              id: false
            }
            em.confirmdeleteachievementdialog = false
            if (action == 'get') {
              em.myachievements = data
            } else {
              em.handleachievements('get')
            }
          })
      },
      setProfilePic(e){
        //this is configured for Evaporate-style uploades... e contains the entire image url and path
        console.log('E',e)
        //let base = 'https://orgbucket-'+this.org.partkey+'.s3-us-west-2.amazonaws.com/'
        //let pic = base + e[0].Key
        let pic = e[0]
        this.updatecol = 'info'
        this.activedataname = 'profilepic'
        this.activedatavalue = pic
        this.uploadtrigger=false
        this.update()
      }
    },
  }



</script>

<style scoped>
    .hf {
        font-weight: 500;
        font-size: 1.5em;
        display: inline-block;
    }

    .hf2 {
        font-weight: 300;
        display: inline-block;
    }

    .infobox {
        border: solid thin #555555;
        border-radius: 3px;
        padding: 5px;
        display: inline-block;
        width: 60px;
        text-align: left;
        float: right;
    }

    .plrl {
        width: 100%;
    }

    .bfab {
        margin-bottom: 10px;
    }

    .flip {
        transform: scaleX(-1);
    }

    .updateinput {
        font-size: 3em;
        text-align: left;
        width: 300px;
        border: solid thin #888888;
    }

    .wd {
        width: 100%;
        max-width: 500px;
    }

    .fakelist {
        margin-left: 5px;
        margin-right: 5px;
        padding: 8px;
        font-size: 1em;
        width: 100%;
    }

    .bottomnav {
        position: fixed;
        z-index: 3;
        height: 56px;
        width: 100%;
        bottom: 0;
        left: 0;
        text-align: center;
    }

    .bottomnav button {
        color: #FFFFFF;
    }

    .bd {
        border: solid thin #888888;
    }
</style>